module.exports = __webpack_public_path__ + "static/10-067ce5c318b880114ab1c4342edaab2b.jpeg";